import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../data.service';
import{ UrlConstant } from '../../../constants/url-constant';
import{ GlobalConstant } from '../../../constants/global-constant';

import{ AppComponent } from '../../../app.component';

import { Slick } from 'ngx-slickjs';
import { MatSnackBar } from "@angular/material/snack-bar";
import { NotificationService } from "../../../services/notification.service";

import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from "../../dialog/confirmation-dialog/confirmation-dialog.component";

import { CustomDialogsComponent } from "../../dialog/custom-dialogs/custom-dialogs.component";

import {MatCalendarCellCssClasses} from '@angular/material/datepicker';


@Component({
  selector: 'app-test-dashboard',
  templateUrl: './test-dashboard.component.html',
  styleUrls: ['./test-dashboard.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TestDashboardComponent implements OnInit {
  slickArrayLength = 5;
  
  config: Slick.Config = {
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots: true,
      autoplay: true,
      autoplaySpeed: 2000 
    }

  getSlickArray(count: number) {
    let slickArray = new Array(count);
    slickArray.push("/assets/img/study/college-board-geo.jpg");
    slickArray.push("/assets/img/study/college-student-geo.jpg");
    slickArray.push("/assets/img/study/online-classes-Engnr.jpg");
    slickArray.push("/assets/img/study/online-classes-grp.jpg");
    slickArray.push("/assets/img/study/online-classes-img.jpg");
    return slickArray;
  }
  
	records: Array<any>;
	activeUserCount = 0;
	activeUserList: Array<any>;

    //today's date
   minDateFilter:Date = new Date();
   maxDateFilter:Date = new Date();
	//any date
  //someDateFilter: Date = new Date(anydate);
   customDateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
     return day !== 0 && day !== 6;
    }
    //encapsulation: ViewEncapsulation.None, is required in Component section
	dateClass = (d: Date): MatCalendarCellCssClasses => {
	    const date = d.getDate();	
	    // Highlight the 1st and 20th day of each month.
	    return (date === 1 || date === 20) ? 'example-custom-date-class' : '';
    }

  constructor(private router: Router, private dataService: DataService,
    public appComponent: AppComponent,
  	public notificationService: NotificationService,
  	public dialog: MatDialog,
  	public customDialog: CustomDialogsComponent,
    private _snackBar: MatSnackBar) {
		// Set the minimum to January 1st of previous years in the past and December 31st 5 year in the future.
	    const currentYear = new Date().getFullYear();
	    this.minDateFilter = new Date(currentYear - 1, 0, 1);
	    this.maxDateFilter = new Date(currentYear + 5, 11, 31);
	 }

  ngOnInit(): void {
  	//this.dataService.sendPostRequest(UrlConstant.apiGetEducationalSystem).subscribe((res: any)=>{
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetEducationalSystem, {}).subscribe((res: any)=>{
      console.log(res);
      this.records = res.data;
    });
    
    this.getActiveUserSession('COUNT');
  }
  public getActiveUserSession(key){ // key => COUNT / DATA
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetActiveUserSession, {"key": key}).subscribe((res: any)=>{
      console.log('apiGetActiveUserSession:' + res);
      if("SUCCESS" === res.status){
      	if(key === 'COUNT')
      	  this.activeUserCount = res.data;
      	else if(key === 'DATA')
      	  this.activeUserList = res.data;
      }
    });
  }
  
  public deleteEducationSystem(id){
  	console.log('hi');
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiDeleteEducationalSystem, {"id":id}).subscribe((res: any)=>{
      console.log(res);
      if("SUCCESS" === res.status){
      	console.log("Record Deleted Successfully");
      	this.router.navigate(['/dashboard', { 'userId': '' }]);
      }
      //if("SUCCESS" === res.status || "FAIL" === res.status ){
      	
    });
  	
  
  }
  


  openSnackBar(message: string, action: string, className: string) {
    this._snackBar.open(message, action, {
      duration: 0,
      panelClass: [className]
    });
  }

  showAlert() {
    this.notificationService.alert("an alert", "notice", () => {
      this.notificationService.success("alert oked");
    });
  }

  showConfirm() {
    this.notificationService.confirmation("it will be gone forever", () => {
      this.notificationService.success("confirm oked");
    },
    'Are you sure?',
     () => {
      this.notificationService.error("confirm canceled");
    });
  }
  
  showConfirmation(){
	  let config = this.dataService.getShallowClone(GlobalConstant.confirmDialogConfig);
	  config.data= this.dataService.getShallowClone(GlobalConstant.confirmDialogConfig.data);
	  config.data.title = "Dashboard Confirmation"
	  //const dialogRef = this.dialog.open(ConfirmationDialogComponent, GlobalConstant.confirmDialogConfig);
	  const dialogRef = this.dialog.open(ConfirmationDialogComponent, config);
	  dialogRef.afterClosed().subscribe(dialogResult => {
	      if(dialogResult == true){
			  this.notificationService.success("confirm oked");
		  } else if(dialogResult == false){
			  this.notificationService.error("confirm canceled");
		  }
	    });
  }
  
  showConfirmCustom(){
	 // const dialogData = new CustomDialogsModel("Confirm Action", "Are you sure ??");
	  //const dialogData = {};
	 this.customDialog.showConfirmCustom();
		
  }
  addEvent(key, event){
	  console.log(key+" - "+ event);
	  this.openSnackBar('Hello', 'Close', 'blue-snackbar')
  }
}
